import { useMemo } from "react";
import { useAppContext } from "../../../../AppContext";
import { getCurrentUserRole } from "../../../../common/infrastructure/helpers/userHelper";
import { UserRole, TransferStatus } from "../../../../common/enums";

/**
 * Derives role-based capabilities for the Доставки feature.
 *
 * Rules:
 *   - View                         → any studio employee (Instructor and up).
 *   - Create + Edit + Delete       → Manager and up.
 */
export const useTransferDialogPermissions = () => {
  const { currentUser } = useAppContext();
  const role = getCurrentUserRole(currentUser);

  return useMemo(() => {
    const isManagerOrUp =
      role !== undefined &&
      role >= UserRole.Employee_Manager;

    const canCreate = isManagerOrUp;
    const canEditPlanned = isManagerOrUp;
    const canEditCompleted = isManagerOrUp;
    const canDelete = isManagerOrUp;

    /** Can the current user edit a transfer with the given status? */
    const canEditStatus = (status: TransferStatus) =>
      status === TransferStatus.Completed ? canEditCompleted : canEditPlanned;

    return {
      role,
      canCreate,
      canEditPlanned,
      canEditCompleted,
      canDelete,
      canEditStatus,
    };
  }, [role]);
};
